import React, { useState } from 'react';
import * as yup from 'yup';
import swal from 'sweetalert';
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from 'react-i18next';
import './Modal.scss'

const Modal = (props) => {
  const { t, i18n } = useTranslation();
  const [nombre, colocarNombre] = useState("");
  const [tel, colocarTel] = useState("");
  const [email, colocarEmail] = useState("");
  const [recaptcha, setreCaptcha] = useState("");
  const [errors, setErrors] = useState([]);

  const validationSchema = yup.object({
    nombre: yup.string().required("El nombre es requerido"),
    tel: yup.string()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "El número de teléfono no es válido"
      ).min(10, "Mínimo 10 dígitos")
      .max(10, "Máximo 10 dígitos")
      .required("El teléfono es requerido"),
    email: yup.string().email(),
    recaptcha: yup.string().required("Resuelva el recaptcha")
  });

  // Función para PDF por idioma
  const getBrochurePdf = () => {
    return i18n.language === 'en' 
      ? '/assets/brochure/BROCHURE_VELASUR_EN_Oct2025.pdf' 
      : '/assets/brochure/BROCHURE_VELASUR_Oct2025.pdf';
  };

  // ← NUEVA FUNCIÓN para página de gracias por idioma
  const getThankYouPage = () => {
    return i18n.language === 'en' 
      ? 'https://velasur.mx/thankyou.html' 
      : 'https://velasur.mx/gracias.html';
  };

  const obtenerSiguienteID = async () => {
    try {
      const response = await fetch("https://vistavelasunset.grupovelas.com/get_next_id.php");
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      const data = await response.json();
      return data.next_id || null;
    } catch (error) {
      console.error("Error al obtener el siguiente ID:", error);
      return null;
    }
  };

  const getUTMData = () => {
    const params = new URLSearchParams(window.location.search);
    const referrer = document.referrer || "direct";

    return {
      utm_source: params.get("utm_source") || (referrer !== "direct" ? new URL(referrer).hostname.replace("www.", "") : "direct"),
      utm_medium: params.get("utm_medium") || (referrer !== "direct" ? "referral" : "none"),
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || "",
      referrer: referrer,
      current_url: window.location.href
    };
  };

  const descargarBrochure = () => {
    const link = document.createElement("a");
    link.href = getBrochurePdf();
    link.target = "_blank";
    link.download = i18n.language === 'en' ? "Velasur_Brochure_EN.pdf" : "Brochure_Velasur.pdf";
    link.click();
  };

  const submitForm = async (event) => {
    event.preventDefault();

    const values = { nombre, tel, email, recaptcha };
    const isFormValid = await validationSchema.isValid(values);

    if (!isFormValid) {
      validationSchema.validate(values, { abortEarly: false }).catch((error) => {
        const errorMsgs = error.inner.map((err) => err.errors[0]);
        setErrors(errorMsgs);
      });
      return;
    }

    const siguienteID = await obtenerSiguienteID();
    if (!siguienteID) {
      swal("Error", "No se pudo obtener el siguiente ID.", "error");
      return;
    }

    const utmData = getUTMData();

    const data = {
      id: siguienteID,
      Nombre: nombre,
      Apellidos: "Sin Apellido",
      Telefono: tel,
      Movil: tel,
      Correo: email,
      Descripcion: "no hay comentario",
      ClaveDesarrollo: "qro-005",
      Campana: "CP-0160",
      Medio: "MPUB-0022",
      CorreoAgente: "erios@velasresorts.com",
      CorreoAgenteTitular: "erios@velasresorts.com",
      TipoPersona: "F",
      referer: utmData.current_url,
      utm_source: utmData.utm_source,
      utm_medium: utmData.utm_medium,
      utm_campaign: utmData.utm_campaign,
      utm_term: utmData.utm_term,
      utm_content: utmData.utm_content,
      referrer: utmData.referrer
    };

    const dataVelasur = {
      Nombre: nombre,
      Telefono: tel,
      Correo: email,
      ...utmData
    };

    console.log("Enviando a vistavelasunset:", data);
    console.log("Enviando a velasur:", dataVelasur);

    try {
      const response1 = await fetch("https://vistavelasunset.grupovelas.com/send_lead.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const data1 = await response1.json();
      console.log("Respuesta de vistavelasunset:", data1);

      const response2 = await fetch("https://velasur.mx/php/index.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataVelasur),
      });
      const data2 = await response2.json();
      console.log("Respuesta de velasur:", data2);

      if (response1.ok && response2.ok) {
        // ← MENSAJE DE ÉXITO TRADUCIBLE
        swal("Enviado", t('modal.exito'), "success");
        colocarNombre("");
        colocarTel("");
        colocarEmail("");
        setreCaptcha("");
        descargarBrochure();

        // ← REDIRECCIÓN DINÁMICA POR IDIOMA
        setTimeout(() => {
          window.location.href = getThankYouPage();
        }, 2000);

      } else {
        throw new Error("Error en la respuesta del servidor");
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      swal("Error", t('modal.error'), "error");
    }
  };

  return (
    <div className='contenedor_modal'>
      <p onClick={() => { props.setModal(false) }} className='closed'>X</p>
      <div className='contenedor_modal_form'>
        <img src="/assets/Logos/svg-logo-velasur.svg" alt="" />
        <p>{t('modal.descargarBrochure')}</p>

        <div className="errores">
          <ul>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>

        <form onSubmit={submitForm} id="Brochure">
          <input type="text" placeholder={t('modal.nombre')} value={nombre} onChange={(e) => colocarNombre(e.target.value)} required />
          <input type="text" placeholder={t('modal.telefono')} value={tel} onChange={(e) => colocarTel(e.target.value)} required pattern="[0-9]{10}" />
          <input type="email" placeholder={t('modal.correo')} value={email} onChange={(e) => colocarEmail(e.target.value)} required />
          <p>Al enviar acepta nuestra <a onClick={() => { props.setModalAviso(true) }}>{t('modal.politicaPrivacidad')}</a></p>
          <ReCAPTCHA sitekey="6Lcti0YfAAAAAJ82nMtSbh-N19afeVlBRUp10qhB" onChange={setreCaptcha} />
          <button type="submit" className="button_send">{t('modal.enviar')}</button>
        </form>
      </div>
    </div>
  );
};

export default Modal;
